export default __webpack_public_path__ + "static/media/medal.83a59339.svg";